import { useContext, useEffect, useRef } from 'react';
import { useChat } from '@ai-sdk/react';
import { DefaultChatTransport, type UIMessage } from 'ai';
import { AuthContext } from '@/contexts/AuthContext';
import { BASE_SERVER_URL } from '@/globals';

// Module-level state that persists across component mounts
const processedToolCallIds = new Set<string>();
let sharedTransport: InstanceType<typeof DefaultChatTransport> | null = null;
let savedMessages: UIMessage[] = [];

function getTransport(authApi: any) {
  if (!sharedTransport) {
    sharedTransport = new DefaultChatTransport({
      api: `${BASE_SERVER_URL}/api/v1/ai-chat`,
      fetch: async (url, options) => {
        const currentUser = authApi.getCurrentUser();
        const token = currentUser ? await currentUser.getIdToken() : '';
        return fetch(url, {
          ...options,
          headers: { ...options?.headers, Authorization: `Bearer ${token}` },
        });
      },
    });
  }
  return sharedTransport;
}

export function useAIChat() {
  const { authApi } = useContext(AuthContext);
  const transportRef = useRef(getTransport(authApi));
  const processedToolCalls = useRef(processedToolCallIds);

  const chat = useChat({
    transport: transportRef.current,
    messages: savedMessages.length > 0 ? savedMessages : undefined,
  });

  // Persist messages to module-level variable so they survive unmount
  useEffect(() => {
    savedMessages = chat.messages;
  }, [chat.messages]);

  return { ...chat, processedToolCalls };
}
